import { enableZodJitless } from '@moment/domain-types/zod-jitless'

// Synchronous top-level code here is guaranteed to run before hydration —
// and so before any app module can parse a zod schema. See "Execution timing":
// https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client
//
// Why the import comes from @moment/domain-types (and why that file is plain
// JS): see zod-jitless.js and "instrumentation-client.ts workspace imports"
// in the root discoveries.md.
enableZodJitless()
